import React from "react";

export const LandingVerticalExperienceIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="32.5957" cy="32.5957" r="32.5957" fill="#0033FF" fillOpacity="0.15" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.2361 16.8359H39.9517H39.9553C42.1805 16.8359 43.988 18.647 43.988 20.8686V44.3229C43.988 46.548 42.1768 48.3555 39.9553 48.3555H25.2361C23.0109 48.3555 21.2034 46.5444 21.2034 44.3229V20.8686C21.2034 18.6434 23.0145 16.8359 25.2361 16.8359ZM39.9517 46.1556C40.9635 46.1556 41.7844 45.3346 41.7844 44.3229H41.788V20.8686C41.788 19.8568 40.9671 19.0359 39.9553 19.0359H25.2361C24.2243 19.0359 23.4034 19.8568 23.4034 20.8686V44.3229C23.4034 45.3346 24.2243 46.1556 25.2361 46.1556H39.9517Z"
      fill="#0033FF"
    />
    <path
      d="M31.797 28.1356C30.874 27.4667 29.5856 28.1297 29.5856 29.2692V35.9222C29.5856 37.0621 30.8802 37.7185 31.797 37.0558L36.3871 33.7293C37.1552 33.1719 37.1552 32.0258 36.3871 31.4684L31.797 28.1419V28.1356Z"
      fill="#0033FF"
    />
  </svg>
);

export const LandingPostExperienceIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle opacity="0.15" cx="32.5957" cy="32.5957" r="32.5957" fill="#0033FF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.1378 16.5957H43.0486H43.0537C46.2156 16.5957 48.784 19.1693 48.784 22.3261V42.8654C48.784 46.0273 46.2105 48.5957 43.0537 48.5957H22.1378C18.9759 48.5957 16.4075 46.0221 16.4075 42.8654V22.3261C16.4075 19.1641 18.981 16.5957 22.1378 16.5957ZM43.0486 45.4697C44.4863 45.4697 45.6528 44.3031 45.6528 42.8654H45.658V22.3261C45.658 20.8884 44.4915 19.7218 43.0537 19.7218H22.1378C20.7001 19.7218 19.5336 20.8884 19.5336 22.3261V42.8654C19.5336 44.3031 20.7001 45.4697 22.1378 45.4697H43.0486Z"
      fill="#0033FF"
    />
    <g opacity="0.35">
      <path d="M23.1299 25.446L41.7217 25.446C42.3141 25.446 42.7943 24.9658 42.7943 24.3734C42.7943 23.781 42.3141 23.3008 41.7217 23.3008L23.1299 23.3008C22.5376 23.3008 22.0573 23.781 22.0573 24.3734C22.0573 24.9658 22.5376 25.446 23.1299 25.446Z" fill="#0033FF" />
      <path d="M23.1299 29.111L41.7217 29.111C42.3141 29.111 42.7943 28.6308 42.7943 28.0384C42.7943 27.446 42.3141 26.9658 41.7217 26.9658L23.1299 26.9658C22.5376 26.9658 22.0573 27.446 22.0573 28.0384C22.0573 28.6308 22.5376 29.111 23.1299 29.111Z" fill="#0033FF" />
      <path d="M23.13 32.7761L39.1918 32.7761C39.7842 32.7761 40.2644 32.2958 40.2644 31.7035C40.2644 31.1111 39.7842 30.6309 39.1918 30.6309L23.13 30.6309C22.5376 30.6309 22.0574 31.1111 22.0574 31.7035C22.0574 32.2958 22.5376 32.7761 23.13 32.7761Z" fill="#0033FF" />
      <path d="M23.13 36.4411L36.662 36.4411C37.2544 36.4411 37.7346 35.9609 37.7346 35.3685C37.7346 34.7761 37.2544 34.2959 36.662 34.2959L23.13 34.2959C22.5376 34.2959 22.0574 34.7761 22.0574 35.3685C22.0574 35.9609 22.5376 36.4411 23.13 36.4411Z" fill="#0033FF" />
    </g>
  </svg>
);

export const LandingDiscoverExperienceIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="32.5957" cy="32.5957" r="32.5957" fill="#0033FF" fillOpacity="0.15" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.8662 41.0231L45.9976 48.1492C46.5919 48.7443 47.5519 48.7443 48.1462 48.1492C48.7405 47.5549 48.7405 46.5888 48.1462 45.9946L41.0224 38.8685C42.9043 36.521 44.0243 33.5458 44.0243 30.31C44.0243 22.7412 37.8757 16.5957 30.31 16.5957C22.7443 16.5957 16.5957 22.7412 16.5957 30.31C16.5957 37.8788 22.7443 44.0243 30.31 44.0243C33.5481 44.0243 36.5195 42.9012 38.8662 41.0231ZM30.31 19.6433C36.1995 19.6433 40.9767 24.4228 40.9767 30.31C40.9767 36.1972 36.1995 40.9767 30.31 40.9767C24.4205 40.9767 19.6433 36.1972 19.6433 30.31C19.6433 24.4228 24.4205 19.6433 30.31 19.6433Z"
      fill="#0033FF"
    />
  </svg>
);

export const LandingActionArrowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="20.7495" cy="20.7495" r="20.7495" fill="#0033FF" />
    <path
      d="M24.9211 19.7499L19.5571 14.3859L20.9713 12.9717L28.7495 20.7499L20.9713 28.528L19.5571 27.1138L24.9211 21.7499H12.7495V19.7499H24.9211Z"
      fill="#FAECF7"
    />
  </svg>
);
